import type { PropsWithChildren } from 'react'
import { useOutletContext } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import EditLocationWorkplaceForm from 'modules/locations/components/LocationWorkplacesForms/Edit/index'

const WorkplaceDetailsComponent = ({ children }: PropsWithChildren) => {
  const { locationId } = useOutletContext<{ locationId: string }>()

  return (
    <ResponsivePage.Body variant="narrow" showHeader={false}>
      {children}
      <EditLocationWorkplaceForm locationId={locationId} />
    </ResponsivePage.Body>
  )
}

export default WorkplaceDetailsComponent
